export function renderNotFoundPage() {
  return `
    <main>
      <section class="contact-section">
        <div class="contact-intro">
          <p class="eyebrow">404</p>
          <h1>Page Not Found</h1>
          <p>This page is not available yet.</p>
          <a class="back-link" href="/" data-route>Back home</a>
        </div>
      </section>
    </main>
  `;
}
